/* eslint-disable react/no-array-index-key */
import { MeasurementTypeDef } from "gql/generated/types";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React from "react";

type DeviceTypesProps = {
  types: MeasurementTypeDef[];
  setTypes: React.Dispatch<React.SetStateAction<MeasurementTypeDef[]>>;
}

const DeviceTypes: React.FC<DeviceTypesProps> = ({ types, setTypes }) => {
  
  return (
    <div>
      {types.length > 0 &&
        types.map((type, index) => (
          <DeviceType key={index} index={index} type={type} setTypes={setTypes} />
        ))}

      <Button
        icon="pi pi-plus"
        className="p-button-rounded p-button-success p-button-sm mt-3"
        title="Add new type"
        onClick={() => setTypes(prev => [...prev, { id: "", title: "" }])}
      />
    </div>
  );
}

export default DeviceTypes;

type DeviceTypeProps = {
  index: number
  type: MeasurementTypeDef;
  setTypes: React.Dispatch<React.SetStateAction<MeasurementTypeDef[]>>;
}

const DeviceType: React.FC<DeviceTypeProps> = ({ index, type, setTypes }) => {
  return <div className="p-inputgroup w-30rem mt-2">
    <InputText
      value={type.id}
      onChange={e => setTypes(prev => prev.map((t, i) => i === index ? { ...t, id: e.target.value } : t))}
      className="p-inputtext-sm"
      placeholder="write id..."
    />
    <InputText
      value={type.title}
      onChange={e => setTypes(prev => prev.map((t, i) => i === index ? { ...t, title: e.target.value } : t))}
      className="p-inputtext-sm"
      placeholder="write title..."
    />
    <Button
      type="button"
      icon="pi pi-times"
      className="p-button-danger p-inputgroup-addon"
      onClick={() => setTypes(prev => prev.toSpliced(index, 1))}
    />
  </div>
}